// Per conventions/code-standards.md ("Error classes carry a name property") and
// languages/typescript.md ("Error classes — minification-safe name"): a per-class
// `static readonly errorName` string literal, copied onto `this.name` in the constructor, so the
// identity survives both JSON serialization and minification (a minifier rewrites the class name
// itself, but never the string literal held in a static field).
export class GoogleTagManagerLoadError extends Error {
    static readonly errorName: string = 'GoogleTagManagerLoadError';

    constructor(message: string) {
        super(message);
        this.name = GoogleTagManagerLoadError.errorName;
    }
}
